import type { FeatureMode } from './compare-url'

// Shared by the server-rendered catalog preview and the interactive directory.
export enum SortOption {
  Featured = 'featured',
  TopRated = 'score',
  PriceLow = 'price_low',
  PriceHigh = 'price_high',
  Newest = 'newest',
}

export interface DirectoryFilters {
  classification: string[]
  tags: string[]
  channels: string[]
  accessories: string[]
  hardware: string[]
  software: string[]
  loss: string[]
  style: string[]
  brand: string
  featureMode: FeatureMode
}

export type FilterArrayKey = Exclude<keyof DirectoryFilters, 'brand' | 'featureMode'>

export const INITIAL_FILTERS: DirectoryFilters = {
  classification: [],
  tags: [],
  channels: [],
  accessories: [],
  hardware: [],
  software: [],
  loss: [],
  style: [],
  brand: '',
  featureMode: 'and',
}
